// API error handling shared by the dark store screens.
//
// The axios interceptor (src/services/api-utils.js) already toasts
// `response.data.message` on a 400, so a screen only shows its own string
// when that message was empty. Each feature supplies its code → i18n key map.

/**
 * Pulls the error CODE out of an axios error. The backend sends
 * `{ message, error: e.message, ...e.data }`, and `e.message` is the
 * CustomError code (`CustomError(400, 'LABEL_OLD')`).
 */
export function extractErrorCode(error) {
  const data = error?.response?.data || {};
  return data.error || data.code || null;
}

/** True when the interceptor had no `message` to show. */
export function shouldShowLocalError(error) {
  const data = error?.response?.data || {};
  return !data.message;
}
